<template>
    <div class="waterMonitorIndex">
      水质监测主页
    </div>
</template>

<script>
import url from "../../service/base-url.js";
export default {
  name: "waterMonitorIndex",
  mounted() {
    // var win = window.open(url.smartDevice, "_blank");
    // win.focus();
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
